import React from 'react'
import type { IconAttributes } from 'zaptic-icon'

type DialogWithIconProps = {
    iconName: IconAttributes['icon-name']
    title: string
    description: string
    primaryButton: {
        label: string
        onClick: () => void
    }
    secondaryButton: {
        label: string
        onClick: () => void
    }
}

export const DialogWithIcon = (props: DialogWithIconProps): JSX.Element => (
    <zaptic-modal>
        <div className="UI_DialogWithIcon">
            <div className="UI_DialogWithIcon__image">
                <zaptic-icon icon-name={props.iconName}></zaptic-icon>
            </div>
            <div className="UI_DialogWithIcon__text">
                <div className="UI_DialogWithIcon__title">{props.title}</div>
                <div className="UI_DialogWithIcon__description">{props.description}</div>
            </div>
            <div className="UI_DialogWithIcon__buttons">
                <zaptic-button type="primary" size="large" onClick={props.primaryButton.onClick}>
                    {props.primaryButton.label}
                </zaptic-button>
                <zaptic-button type="secondary" size="large" onClick={props.secondaryButton.onClick}>
                    {props.secondaryButton.label}
                </zaptic-button>
            </div>
        </div>
    </zaptic-modal>
)
